import styled from 'styled-components'
import { SvgRenderer } from '~common/components/svg-renderer'
import { useTheme } from '~common/theme/theme-provider'

interface ImportStartedProps {
    message: string
    onClose: () => void
}

export default function ImportStarted({
    message,
    onClose,
}: ImportStartedProps) {
    const { isDark } = useTheme()

    const image = isDark
        ? '/assets/images/couch-success-dm.svg'
        : '/assets/images/couch-success.svg'

    return (
        <Container>
            <Header>
                <SvgRenderer
                    src={image}
                    alt="Checkout successful"
                    height="250px"
                    width="250px"
                />
                <Title>Congrats! You're all set!</Title>
            </Header>
            <Body>
                We'll import the rest of the invoices from the rest of <br />
                the emails that have already been scanned. <br />
                Keep your tab open.
            </Body>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: ${({ theme }) => theme.spacing[6]};
    gap: ${({ theme }) => theme.spacing[4]};
`

const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
`

const Title = styled.h2`
    font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
`

const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    color: ${({ theme }) => theme.colors.text.secondary};
    p {
        margin: 0;
    }
`

const Footer = styled.div`
    margin-top: ${({ theme }) => theme.spacing[4]};
`
